import { useMemo } from 'react'

import {
  DEFAULT_TENANT_FEATURES,
  normalizeTenantFeatures,
  type TenantFeatureKey,
  type TenantFeatures,
} from '@/constants/tenant-features'
import { useAuthConfig } from './useAuthConfig'

/** 当前租户已开通的功能模块(来自 GET /auth/config) */
export function useTenantFeatures() {
  const { config, loading, error, reload } = useAuthConfig()

  const features: TenantFeatures = useMemo(
    () => normalizeTenantFeatures(config?.features ?? DEFAULT_TENANT_FEATURES),
    [config?.features],
  )

  const isEnabled = (key: TenantFeatureKey) => {
    if (key === 'contests_global_catalog' || key === 'tasks_global_catalog') {
      return features[key] === true
    }
    return features[key] !== false
  }

  return { features, isEnabled, loading, error, reload, config }
}
